import { gql } from "@apollo/client";

/**
 * Mutation to upload a video to a match
 * Uploads video file to YouTube and associates it with the match
 */
export const UPLOAD_VIDEO_TO_MATCH = gql`
  mutation UploadVideoToMatch($matchId: ID!, $file: Upload!) {
    uploadVideoToMatch(matchId: $matchId, file: $file) {
      id
      title
      description
      youtubeUrl
      youtubeVideoId
      thumbnail
      duration
      uploadedAt
      uploadedBy
    }
  }
`;

/**
 * Query to get all videos for a specific match
 * Returns match data including associated videos
 */
export const GET_MATCH_VIDEOS = gql`
  query GetMatchVideos($id: ID!) {
    match(id: $id) {
      id
      videos {
        id
        title
        description
        youtubeUrl
        youtubeVideoId
        thumbnail
        duration
        uploadedAt
        uploadedBy
      }
    }
  }
`;
